// extracted by mini-css-extract-plugin
export default {"close":"Closebutton_close__flpbp"};